import DDUMain from "./components/main/main"
import DDUFooter from "./components/footer/footer";

function DDU( {value, userData, changeHUD, setChangeHUD, leaderboard} ) {
    return (
        <div className="w-[calc(100%-15px)] h-[calc(100%-15px)] flex flex-col gap-4 min-w-[680px] min-h-[360px]">
            <DDUMain value={value} userData={userData} changeHUD={changeHUD} setChangeHUD={setChangeHUD} leaderboard={leaderboard}/>

            <DDUFooter value={value}/>
        </div>
    );
}

export default DDU;